import { useAuthStore } from '@/stores/auth'
import { useFECompanyStore } from '@/stores/feCompany'
import { useFEDashBoardStore } from '@/stores/feDashboard'
import { useFEUserProfileStore } from '@/stores/feUserProfile'
import { useOrgSortTagStore } from '@/stores/orgSortTag'
import { useRegisterStore } from '@/stores/register'
import { useShortUrlStore } from '@/stores/shortUrl'
import { useUserMgmtProfileStore } from '@/stores/userMgmtProfile'

type StoreInitializer<T> = () => T

class AppStore {
  private stores: Record<string, any> = {}

  private getStore<T>(storeName: string, initializer: StoreInitializer<T>): T {
    if (!this.stores[storeName]) {
      this.stores[storeName] = initializer()
    }
    return this.stores[storeName]
  }

  get useAuthStore(): ReturnType<typeof useAuthStore> {
    return this.getStore('useAuthStore', useAuthStore)
  }

  get useUserMgmtProfileStore() {
    return this.getStore('useUserMgmtProfileStore', useUserMgmtProfileStore)
  }

  get useFECompanyStore() {
    return this.getStore('useFECompanyStore', useFECompanyStore)
  }

  get useShortUrlStore() {
    return this.getStore('useShortUrlStore', useShortUrlStore)
  }

  get useFEUserProfileStore() {
    return this.getStore('useFEUserProfileStore', useFEUserProfileStore)
  }

  get useRegisterStore() {
    return this.getStore('useRegisterStore', useRegisterStore)
  }

  get useFEDashBoardStore() {
    return this.getStore('useFEDashBoardStore', useFEDashBoardStore)
  }

  get useOrgSortTagStore() {
    return this.getStore('useOrgSortTagStore', useOrgSortTagStore)
  }
}

const appStore = new AppStore()

export default appStore
